import Button from 'components/Button';
import useAuth from 'hooks/useAuth';
import { analytics } from 'lib/analytics';
import Link from 'next/link';
import style from './AnnouncementBanner.module.css';

//Can be transformed to a multi-use component through props
export default function AnnouncementBanner() {
  const [user] = useAuth();
  const bannerAnalytics = () => {
    analytics.generic(user, 'API announcement banner clicked');
  };
  return (
    <Link
      className={style.container}
      href={'http://www.cleeai.com/products/ai-chatbot/#form'}
      target={'_blank'}
      onClick={bannerAnalytics}
    >
      <div className={style.left}>
        <span className={style.star}>🌟</span>
        <p className={style.headline}>Elevate Sales with AI</p>
        {/* <p className={style.ctaText}>Register your interest for</p> */}
      </div>
      <Button className={style.btn} variant={'secondary'}>
        Get early access
      </Button>
    </Link>
  );
}
